export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70c62264acaac2158a84af84afea1c6683c698a4c3&name=pushAdClickData!'